module.exports = __webpack_public_path__ + "img/mapeoGastos.7e41d443.svg";